import EventBus from '@/eventBus'

const MESSAGE_TYPES = {
  SLIDE_OPTION: 'slideOption',
}

function handleCreateOption(doc, editor) {
  if (doc.action === 'audience-create') {
    if (editor.slideActive.type === 'openEnded') {
      if (editor.slideActive.id === doc.data.slideId) {
        EventBus.$emit('new-open-ended-response', doc.data)
      }

      return
    }

    const matchSlide = editor.presentation.slides.find((slide) => slide.id === doc.data.slideId)
    if (!matchSlide) return

    const newSlideOptions = [...matchSlide.SlideOptions, doc.data]
    editor.patchSlideByIdAction({
      id: doc.data.slideId,
      SlideOptions: newSlideOptions,
    })
  }
}

const SlideOptionWebsocketSubscriber = {
  [MESSAGE_TYPES.SLIDE_OPTION]: handleCreateOption,
}

export default SlideOptionWebsocketSubscriber
